import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ICalendarSection, ICalendarBusyTime } from '../../../interfaces/scheduler_interfaces';
import { ITypedModel } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Model } from 'utility-ts-orm';

interface ICalendarTimesModel {
  busy_times: ICalendarBusyTime[];
  section_times: ICalendarSection[];
  loaded_times: boolean;
}

export type CalendarTimesModel = ITypedModel<ICalendarTimesModel>;

angular.module('capability-ng-scheduler').factory(
  'ngCalendarTimesModel',
  () =>
    new Model<ICalendarTimesModel>({
      busy_times: [],
      section_times: [],
      loaded_times: false
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/models/calendar_times_model.ts